import React from 'react';
import clsx from 'clsx';
import Button from '@mui/material/Button';

function PurchaseButton({ className }) {
	return (
		<Button
			component="a"
			href="https://wisesolutions.it"
			target="_blank"
			rel="noreferrer noopener"
			role="button"
			className={clsx('normal-case', className)}
			variant="text"
			// color="secondary"
		>
			<span className="mx-4">Wise Solutions srl</span>
		</Button>
	);
}

export default PurchaseButton;
